/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

/**
 * Common SVG Icons
 */
import { ReactComponent as Add } from "assets/images/icons/common/circlue-plus-solid.svg";
import { ReactComponent as AddForm } from "assets/images/icons/common/file-circle-plus-regular.svg";
import { ReactComponent as AddPage } from "assets/images/icons/common/file-circle-plus-regular.svg";
import { ReactComponent as AddWebsite } from "assets/images/icons/common/file-circle-plus-regular.svg";
import { ReactComponent as AddOutlined } from "assets/images/icons/common/circle-plus-outline.svg";
import { ReactComponent as AddPageBreak } from "assets/images/icons/common/add-page-break-common.svg";
import { ReactComponent as AddStep } from "assets/images/icons/common/circle-1-regular-full.svg";
import { ReactComponent as Alert } from "assets/images/icons/models/alert-model.svg";
import { ReactComponent as Approve } from "assets/images/icons/common/check-regular.svg";
import { ReactComponent as Avatar } from "assets/images/icons/common/avatar.svg";
import { ReactComponent as Back } from "assets/images/icons/common/arrow-left-regular.svg";
import { ReactComponent as Bell } from "assets/images/icons/common/bell-regular.svg";
import { ReactComponent as BellActive } from "assets/images/icons/common/bell-bold.svg";
import { ReactComponent as BellFill } from "assets/images/icons/common/bell-regular-fill.svg";
import { ReactComponent as BellFillActive } from "assets/images/icons/common/bell-bold-fill.svg";
import { ReactComponent as Browse } from "assets/images/icons/components/list-tree-solid.svg";
import { ReactComponent as Cancel } from "assets/images/icons/common/cancel.svg";
import { ReactComponent as ChevronRight } from "assets/images/icons/common/chevron-right-regular.svg";
import { ReactComponent as Clipboard } from "assets/images/icons/common/clipboard-regular.svg";
import { ReactComponent as Clock } from "assets/images/icons/common/clock-regular.svg";
import { ReactComponent as Close } from "assets/images/icons/common/xmark-regular.svg";
import { ReactComponent as CloseDark } from "assets/images/icons/common/xmark-dark.svg";
import { ReactComponent as Clouds } from "assets/images/icons/common/clouds-solid.svg";
import { ReactComponent as Copy } from "assets/images/icons/common/copy-regular.svg";
import { ReactComponent as CopyDark } from "assets/images/icons/common/copy-dark.svg";
import { ReactComponent as CopySolid } from "assets/images/icons/common/copy-solid.svg";
import { ReactComponent as Create } from "assets/images/icons/common/plus.svg";
import { ReactComponent as Delete } from "assets/images/icons/common/trash.svg";
import { ReactComponent as Download } from "assets/images/icons/common/arrow-down-to-line-regular.svg";
import { ReactComponent as Draft } from "assets/images/icons/common/pen-regular.svg";
import { ReactComponent as Duplicate } from "assets/images/icons/common/copy-regular.svg";
import { ReactComponent as Edit } from "assets/images/icons/common/edit.svg";
import { ReactComponent as Ellipsis } from "assets/images/icons/common/ellipsis-regular.svg";
import { ReactComponent as Email } from "assets/images/icons/common/email.svg";
import { ReactComponent as ExternalLink } from "assets/images/icons/common/external-link-common.svg";
import { ReactComponent as Feedback } from "assets/images/icons/common/comment-regular.svg";
import { ReactComponent as Filter } from "assets/images/icons/common/bars-filter-solid.svg";
import { ReactComponent as Help } from "assets/images/icons/common/circle-question-regular.svg";
import { ReactComponent as Inbox } from "assets/images/icons/common/inbox-regular.svg";
import { ReactComponent as Info } from "assets/images/icons/common/circle-info-regular.svg";
import { ReactComponent as InternalLink } from "assets/images/icons/common/file-regular.svg";
import { ReactComponent as LineChart } from "assets/images/icons/common/chart-line-solid.svg";
import { ReactComponent as ListSolid } from "assets/images/icons/common/list-solid.svg";
import { ReactComponent as ManageRule } from "assets/images/icons/common/arrow-split-two-right.svg";
import { ReactComponent as Message } from "assets/images/icons/common/message-solid.svg";
import { ReactComponent as NotificationImage } from "assets/images/icons/common/notification-image-common.svg";
import { ReactComponent as Page } from "assets/images/icons/common/file-regular.svg";
import { ReactComponent as PenToSquare } from "assets/images/icons/common/pen-to-square-regular.svg";
import { ReactComponent as Preview } from "assets/images/icons/common/eye-regular.svg";
import { ReactComponent as Published } from "assets/images/icons/common/circle-check-regular.svg";
import { ReactComponent as PublishedSolid } from "assets/images/icons/common/circle-check-solid.svg";
import { ReactComponent as Recycle } from "assets/images/icons/common/recycle-solid.svg";
import { ReactComponent as RightArrow } from "assets/images/icons/common/arrow-right-regular.svg";
import { ReactComponent as RequestReview } from "assets/images/icons/common/share-regular.svg";
import { ReactComponent as Save } from "assets/images/icons/common/save.svg";
import { ReactComponent as Search } from "assets/images/icons/common/search.svg";
// import { ReactComponent as SimpliCityLogo } from "assets/images/icons/common/SimpliCity-logo-139w.svg";
import { ReactComponent as SimpliCityLogo } from "assets/images/icons/common/simplicity-wordmark-white.svg";
// import { ReactComponent as SimpliCityLogoSmall } from "assets/images/icons/common/simplicity-icon-24-new.svg";
import { ReactComponent as SimpliCityLogoSmall } from "assets/images/icons/common/simplicity-logo-white.svg";
import { ReactComponent as SimpliCityLogoSmallTransparent } from "assets/images/icons/common/SCWordmarkSmall_no_colour.svg";
import { ReactComponent as SquareQuestionSolid } from "assets/images/icons/common/square-question-solid.svg";
import { ReactComponent as Sort } from "assets/images/icons/common/arrow-down-a-z-regular.svg";
import { ReactComponent as SortReverse } from "assets/images/icons/common/arrow-down-z-a-regular 1.svg";
import { ReactComponent as Survey } from "assets/images/icons/common/survey-regular.svg";
import { ReactComponent as Table } from "assets/images/icons/common/table.svg";
import { ReactComponent as TreeCollapse } from "assets/images/icons/common/caret-down-solid.svg";
import { ReactComponent as TreeExpand } from "assets/images/icons/common/caret-right-solid.svg";

/**
 * Navigation SVG Icons
 */
import { ReactComponent as Application } from "assets/images/icons/navigation/application-navigation.svg";
import { ReactComponent as Components } from "assets/images/icons/navigation/components-navigation.svg";
import { ReactComponent as Composer } from "assets/images/icons/navigation/composer-navigation.svg";
import { ReactComponent as Content } from "assets/images/icons/navigation/content-navigation.svg";
import { ReactComponent as ArrowLeftToLine } from "assets/images/icons/navigation/close-drawer-navigation.svg";
import { ReactComponent as DigitalAssets } from "assets/images/icons/navigation/digital-assets-navigation.svg";
import { ReactComponent as DigitalAssetsDocs } from "assets/images/icons/navigation/digital-assets-document-navigation.svg";
import { ReactComponent as DigitalAssetsImages } from "assets/images/icons/navigation/digital-assets-image-navigation.svg";
import { ReactComponent as DigitalAssetsLink } from "assets/images/icons/navigation/link-navigation.svg";
import { ReactComponent as Forms } from "assets/images/icons/navigation/forms-navigation.svg";
import { ReactComponent as Home } from "assets/images/icons/navigation/home-navigation.svg";
import { ReactComponent as ArrowRightToLine } from "assets/images/icons/navigation/open-drawer-navigation.svg";
import { ReactComponent as Organization } from "assets/images/icons/navigation/organization-navigation.svg";
import { ReactComponent as Tasks } from "assets/images/icons/navigation/tasks-navigation.svg";
import { ReactComponent as Websites } from "assets/images/icons/navigation/websites-navigation.svg";

const common = {
    Add,
    AddOutlined,
    AddPageBreak,
    AddStep,
    Alert,
    AddWebsite,
    AddForm,
    AddPage,
    Approve,
    Application,
    ArrowLeftToLine,
    ArrowRightToLine,
    DigitalAssetsDocs,
    DigitalAssetsImages,
    DigitalAssetsLink,
    Avatar,
    Back,
    Bell,
    BellActive,
    BellFill,
    BellFillActive,
    Browse,
    Cancel,
    ChevronRight,
    Clipboard,
    Clock,
    Close,
    CloseDark,
    Clouds,
    Components, 
    Composer,
    Content,
    Create,
    Copy,
    CopyDark,
    CopySolid,
    Draft,
    Delete,
    DigitalAssets,
    Download,
    Duplicate,
    Edit,
    Ellipsis,
    Email,
    Feedback,
    Filter,
    Forms,
    Help,
    Home,
    Info,
    Inbox,
    LineChart,
    ListSolid,
    Message,
    ManageRule,
    NotificationImage,
    Organization,
    Page,
    PenToSquare,
    Preview,
    Published,
    PublishedSolid,
    Recycle,
    RequestReview,
    RightArrow,
    Save,
    Search,
    SimpliCityLogo,
    SimpliCityLogoSmall,
    SimpliCityLogoSmallTransparent,
    SquareQuestionSolid,
    Sort,
    SortReverse,
    Survey,
    Table,
    Tasks,
    TreeCollapse,
    TreeExpand,
    Websites,
    InternalLink,
    ExternalLink,
};

export { common };
